class Field {
    constructor(input) {
        this._input = input;

        input.$$ = this;

        this.initInput(input);
    }

    initInput(input) {
    }

    refresh() {}

    get input() {
        return this._input;
    }

    set value(v) {
        throw new Error('Provide value setter!');
    }

    get value() {
        throw new Error('Provide value getter!');
    }

    get inputParent() {
        return this._input.closest('.form-group').firstElementChild;
    }
}

class InputField extends Field {
    initInput(input) {
        if (input.hasAttribute('placeholder') && !this.inputParent.dataset.placeholder) {
            this.inputParent.dataset.placeholder = input.getAttribute('placeholder');
        }
    
        input.addEventListener('focus', () => {
            if (input.dataset.targetType) {
                input.setAttribute('type', input.dataset.targetType);
            }
    
            this.refresh();
        });

        input.addEventListener('blur', () => {
            if (input.dataset.targetType && !input.value) {
                input.setAttribute('type', 'text');
            }
        });
    
        input.addEventListener('keyup', this.refresh.bind(this));
        input.addEventListener('input', this.refresh.bind(this));
    }

    refresh() {
        this.inputParent.classList.remove('error');

        if (this.input.value) {
            this.inputParent.classList.add('has-value');
        } else {
            this.inputParent.classList.remove('has-value');
        }
    }

    set value(v) {
        this._input.value = v;
    }

    get value() {
        return this._input.value;
    }
}

class CheckboxField extends Field {
    initInput(input) {
        input.addEventListener('change', () => {
        
            this.refresh();
        });
    }

    refresh() {
        this.input.parentElement.classList.remove('error');
    }

    set value(v) {
        this._input.checked = v ? true : false;
    }

    get value() {
        return this._input.checked ? true : false;
    }
}

const SUPPORTED_FIELDS = {
    'text': InputField,
    'tel': InputField,
    'input': InputField,
    'email': InputField,
    'select': InputField,
    'textarea': InputField,
    'checkbox': CheckboxField,
};

export function initForm(formElement) {
    const wpcf7 = formElement.closest('.wpcf7');
    if (wpcf7) {
        wpcf7.addEventListener( 'wpcf7mailsent', () => {
            setTimeout(() => {
                fieldsInstances.forEach(i => {
                    i.refresh();
                });
            })
        });
    }

    const fields = Array.from(formElement.querySelectorAll('*[name]'));
    const fieldsInstances = [];

    for (const field of fields) {
        const type = field.getAttribute('type') || field.tagName.toLowerCase();
        if (!SUPPORTED_FIELDS[type]) {
            continue;
        }

        const c = SUPPORTED_FIELDS[type];
        fieldsInstances.push(new c(field));
    }

    console.log('initForm', formElement, fields, fieldsInstances);
}